const Kategoriya2413 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 4-chorak<br />
                Mavzu: Eng yaxshi ixtirolar <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Gaplarni mantiqan davom ettiring. </b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning gap  haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p>Qushlar galasi goh samoni quchar, goh _________________, goh ________________ qo‘nardi.</p>
            <p>Itlar ajabtovur bezovtalikni sezib, ___________________________________.</p>
            <p><b>2-mashq. Juftlikda ishlang. Quyidagi iboralarni qatnashtirib gaplar tuzing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning gap tuzish bo‘yicha ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">taraddudga tushmoq
_______________________________________________________________
</p>
            <p className="text-break">ter to‘kmoq
_______________________________________________________________
</p>
            <p><b> 3-mashq. FDM usulidan foydalanib, quyidagi fikrni izohlang.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Imloviy savodxonlik hamma uchun birdek zarur.</p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2413;